import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  iniciarSessao: token => {
    return Vue.http.post('/api/acessoMensagens/Sessao', { token })
      .then(resposta => resposta.data);
  },
  lista: (pagina = 1, filtros = {}) => {
    const parametros = Object.assign({}, { pagina }, filtros);
    return Vue.http.get('/api/centralMensagens', { params: parametros })
      .then(resposta => resposta.data);
  },
  exportar: (filtros = {}) => {
    return Vue.http.get('/api/centralMensagens/Exportar', { params: filtros })
      .then(resposta => resposta.data);
  },
  avisos: token => {
    return Vue.http.get('/api/centralMensagens/Avisos', { headers: { Authorization: token } })
      .then(resposta => resposta.data);
  },
  meusAvisos: token => {
    return Vue.http.get('/api/centralMensagens/MeusAvisos', { headers: { Authorization: token } })
      .then(res => res.data);
  },
  salvarMeusAvisos: (token, chaves) => {
    return Vue.http.put('/api/centralMensagens/MeusAvisos', { chaves }, { headers: { Authorization: token } })
      .then(res => res.data);
  },
  avisosVisto: token => {
    return Vue.http.post('/api/centralMensagens/AvisosVisto', {}, { headers: { Authorization: token } })
      .then(resposta => resposta.data);
  },
  modulos: () => {
    return Vue.http.get('/api/centralMensagens/Modulos')
      .then(resposta => resposta.data);
  },
  conversa: (modulo, id, marcarLida) => {
    return Vue.http.get('/api/centralMensagens/Conversa', { params: { modulo, id, marcarLida } })
      .then(resposta => resposta.data);
  },
  enviar: (modulo, id, texto, interna, idUsuarioDestino = 0) => {
    return Vue.http.post('/api/centralMensagens/Enviar', { modulo, id, texto, interna, idUsuarioDestino })
      .then(resposta => resposta.data);
  },
  usuarios: () => {
    return Vue.http.get('/api/centralMensagens/Usuarios')
      .then(resposta => resposta.data);
  },
  marcarLida: (modulo, id) => {
    return Vue.http.post('/api/centralMensagens/MarcarLida', { modulo, id })
      .then(resposta => resposta.data);
  },
  encerrar: (modulo, id, motivo) => {
    return Vue.http.post('/api/centralMensagens/Encerrar', { modulo, id, motivo })
      .then(resposta => resposta.data);
  },
  reabrir: (modulo, id) => {
    return Vue.http.post('/api/centralMensagens/Reabrir', { modulo, id })
      .then(resposta => resposta.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/central-mensagens/servico.js